import { render, staticRenderFns } from "./UserAuthentication.vue?vue&type=template&id=32b7e07d&scoped=true"
import script from "./UserAuthentication.vue?vue&type=script&lang=js"
export * from "./UserAuthentication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b7e07d",
  null
  
)

export default component.exports